import api from '../utils/axiosConfig';
import { login, logout, setAuthChecking } from '../store/authSlice';
import { toast } from 'react-toastify';

/**
 * Authentication middleware - currently minimal, can be extended for other auth-related logic
 */
export const authMiddleware = store => next => action => {
    return next(action);
};

/**
 * Initialize authentication state by validating stored token
 * Call this immediately after store creation
 */
export const initializeAuth = (store) => {
    const sessionToken = sessionStorage.getItem('token');
    
    if (sessionToken) {
        // Token exists, validate it
        validateTokenAndRehydrateState(store, sessionToken);
    } else {
        // No token, set auth checking to false immediately
        store.dispatch(setAuthChecking(false));
    }
};

/**
 * Function to validate token and rehydrate state
 */
const validateTokenAndRehydrateState = async (store, token) => {
    if (import.meta.env.MODE === 'development') {
        await new Promise(resolve => setTimeout(resolve, 800));
    }
    store.dispatch(setAuthChecking(true));
    try {
        // Make a request to validate the token and get user data
        const response = await api.get('/api/auth/validate');
        if (response.data.valid) {
            // If token is valid, dispatch login action with user data
            store.dispatch(login({
                token,
                user: response.data.user,
                units: response.data.units || [],
                isFirstLogin: response.data.isFirstLogin,
                signedEula: response.data.signedEula,
            }));
        } else {
            store.dispatch(logout());
            toast.error('Session expired. Please log in again.');
        }
    } catch (error) {
        console.error('Error validating token:', error);
        store.dispatch(logout());
        toast.error('Session expired. Please log in again.');
    } finally {
        // Always set auth checking to false when we're done
        store.dispatch(setAuthChecking(false));
    }
};
